<template>
  <div id="" class="mainDiv">
    <div class="head clearfix">
      <el-button
        type="primary"
        size="small"
        @click="goBack"
        class="head-li"
        style="float: left"
        >返回</el-button
      >
      <h3 class="head-li" style="text-align: center">查看作业</h3>
    </div>
    <div class="student-info">
      <div>学生姓名：{{ this.form.uname }}</div>
      <div>手机号：{{ this.form.phone }}</div>
      <div>准考证号：{{ this.form.admissionCard }}</div>
      <div>提交时间：{{ this.form.submitDate }}</div>
    </div>
    <el-form ref="form" :model="form" label-width="140px">
      <el-form-item prop="name" label="作业主题：">
        <p>{{ this.form.homeworkTopic }}</p>
      </el-form-item>
      <el-form-item label="答案附件：">
        <a
          :href="this.form.homeworkHref"
          class="download"
          v-if="this.form.homeworkAccessory != null"
          >{{ this.form.homeworkAccessory }} 点击下载</a
        >
      </el-form-item>
      <!-- <el-form-item label="作业："></el-form-item> -->
      <el-form-item
        label="作业："
        prop="homeworkContent"
        style="position: relative"
      >
        <quill-editor
          ref="quillEditor"
          v-model="form.homeworkContent"
          :options="options"
          style="width: calc(100% - 40px); margin-left: 20px"
          disabled
        >
          <div id="toolbar" slot="toolbar" style="height: 0; padding: 0"></div>
        </quill-editor>
      </el-form-item>
      <el-form-item label="答题结果：">
        <quill-editor
          ref="quillEditor2"
          v-model="form.answerContent"
          :options="options2"
          style="width: calc(100% - 40px); margin-left: 20px"
          disabled
        >
          <div id="toolbar2" slot="toolbar" style="height: 0; padding: 0"></div>
        </quill-editor>
      </el-form-item>
      <el-form-item label="答题附件：" style="border-bottom: 1px solid #cccccc">
        <a
          :href="this.form.answerHref"
          class="download"
          v-if="this.form.answerAccessory != null"
          >{{ this.form.answerAccessory }} 点击下载</a
        >
      </el-form-item>
      <el-form-item label="评分结果：">
        <h3 class="download">{{ this.form.markingScore }}</h3>
      </el-form-item>
      <el-form-item label="评语：">
        <h3 class="download">{{ this.form.markingComment }}</h3>
      </el-form-item>
      <el-form-item label="批阅附件：">
        <a
          :href="this.form.markingHref"
          class="download"
          v-if="this.form.markingAccessory != null"
          >{{ this.form.markingAccessory }} 点击下载</a
        >
      </el-form-item>
      <el-form-item v-if="false" label="查重率：">
        <h3 class="download">{{ this.form.repeatChance }}</h3>
      </el-form-item>
      <el-form-item label="退回次数：">
        <h3 class="download">{{ this.form.sendbackNumber }}</h3>
      </el-form-item>
      <el-form-item label="退回原因：">
        <div
          v-if="
            this.form.sendbackCause !== null &&
            this.form.sendbackCause !== '' &&
            this.form.sendbackCause !== undefined
          "
        >
          <h3
            v-for="(item, index) in this.form.sendbackCause.split(
              '#encryption#'
            )"
            :key="item.id"
          >
            {{ index + 1 }}. {{ item }}
          </h3>
        </div>
      </el-form-item>
      <el-form-item label-width="0px" style="padding: 20px 0">
        <el-button
          type="primary"
          @click="goBack"
          style="margin: 0 20px; width: 98px"
          >返回</el-button
        >
      </el-form-item>
    </el-form>
  </div>
</template>

<script>
import { confirmMsg } from '@/utils/common'
import * as api from '@/api/homework/homework'
import { Quill, quillEditor } from 'vue-quill-editor' //调用编辑器
import 'quill/dist/quill.core.css'
import 'quill/dist/quill.snow.css'
import 'quill/dist/quill.bubble.css'
import '@/assets/css/quill.css'
export default {
  name: 'HomeworkSendback',
  components: {
    quillEditor,
  },
  data() {
    return {
      form: {
        list: [],
        name: '',
        content: '',
        ground: '',
        uploadFileList: [],
        submitDate: [new Date(2021, 2, 1, 0, 0), new Date(2021, 2, 1, 0, 0)],
        attachment: 0,
        attachmentSize: '',
        isCheckRepetition: 0,
        staus: 0,
      },
      options: {
        placeholder: '请输入内容',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar',
        },
      },
      options2: {
        placeholder: '请输入内容',
        theme: 'snow',
        modules: {
          toolbar: '#toolbar2',
        },
      },
      file: '',
      loading: false,
      editBtnStyle: '0',
      showSendback: 0,
    }
  },
  filters: {
    sendbackNumber: function (value1, value2) {
      return (
        '<p style="margin:0px;width:100%;word-break:break-all; white-space: pre-line;">' +
        1 +
        '</p>'
      )
    },
  },
  methods: {
    getdata() {
      let reqdata = {
        answerId: this.$route.query.id,
      }
      api.getHomeworkAnswerInfo(reqdata).then((res) => {
        console.log(res.data.data)
        if (res.data.data != null) {
          this.form = res.data.data
        }
        console.log(this.form)

        this.form.homeworkHref =
          this.url + '/zkfz/zkolHomework/getFile?id=' + res.data.data.hid
        this.form.answerHref =
          this.url + '/zkfz/zkolHomework/getFile?id=' + res.data.data.haid
        this.form.markingHref =
          this.url + '/zkfz/zkolHomework/getFile?id=' + res.data.data.hmid
      })
    },
    goBack() {
      window.history.go(-1)
    },
    onSubmit() {},
  },
  mounted() {
    this.getdata()
  },
  created() {
    const deitStyle = this.$route.query.edit_style
    this.editBtnStyle = deitStyle
    //判断是新增页面还是编辑页面
    if (deitStyle != '0') {
      // this.getParams()
      // this.getFile()
    }
  },
  computed: {
    getUId() {
      return localStorage.getItem('uid') 
    },
    url() {
      let url = window.location.protocol + '//' + window.location.host
      if (window.location.host == 'localhost:5001') {
        url = 'http://gz.hnjk.net'
      }
      return url
    },
  },
}
</script>

<style lang="scss" scoped>
.head {
  margin-bottom: 10px;
}
.clearfix:after {
  content: '';
  height: 0;
  line-height: 0;
  display: block;
  visibility: hidden;
  clear: both;
}
/deep/.ql-editor {
  min-height: 300px;
}
.student-info {
  display: flex;
  justify-content: space-around;
  border-bottom: 1px solid #cccccc;
  padding: 15px;
}
.download {
  color: #0099ff;
  text-decoration: none;
}
.send-back {
  position: fixed;
  width: 50%;
  left: 50%;
  transform: translateX(-50%);
  bottom: 30%;
  border: 1px solid black;
  background-color: white;
  padding: 10px;
}
.send-back-textarea {
  width: 100%;
  padding: 10px;
}
</style>
